module.exports = __webpack_public_path__ + "img/bg_weigui.7421e45d.png";